import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundAntiClockwise12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowRoundAntiClockwise12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.666 5.002c.54-1.855 2.376-2.886 4.257-2.382 1.906.51 2.984 2.379 2.473 4.286-.51 1.907-2.38 2.986-4.285 2.475a3.6 3.6 0 0 1-1.397-.715 3 3 0 0 1-.395-.402l-.014-.02a.5.5 0 0 0-.828.562l.414-.28-.414.28v.001l.002.002.003.005.01.014.032.042q.04.053.113.138c.098.113.242.263.435.425.388.324.974.698 1.78.914 2.44.654 4.856-.742 5.51-3.182s-.74-4.858-3.18-5.511C5.048 1.082 2.932 2.069 2 3.963V2.502a.5.5 0 1 0-1 0v3.5h3.49a.5.5 0 0 0 0-1zm.639 3.243-.001-.001-.001-.002z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundAntiClockwise12);
